import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLanguage } from "../context/LanguageContext";

const TRANSLATIONS = {
  en: {
    subtitle: "Page not found",
    description: "The page you are looking for does not exist.",
    button: "Back to home"
  },
  pt: {
    subtitle: "Página não encontrada",
    description: "A página que procura não existe.",
    button: "Voltar ao início"
  }
};

export default function NotFound() {
  const { language } = useLanguage();
  const t = TRANSLATIONS[language];

  return (
    <div className="relative flex flex-col items-center justify-center flex-grow min-h-[calc(100vh-80px)] w-[100vw] ml-[calc(50%-50vw)] bg-[#0A0A0A] text-white px-6 py-24 text-center overflow-hidden">
      
      {/* IMAGEM DE FUNDO */}
      <div 
        className="absolute inset-0 z-0 bg-cover bg-center blur-[8px] opacity-95 scale-110" 
        style={{ 
          backgroundImage: "url('https://customer-assets.emergentagent.com/job_solar-scada-monitor/artifacts/q0jcs6xp_PV%20Plant%202.jpg')" 
        }}
      />
      
      {/* CAMADA ESCURA */}
      <div className="absolute inset-0 z-[1] bg-black/60" />

      {/* CONTEÚDO */}
      <motion.div
        className="relative z-[2]" 
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <h1 className="text-[100px] md:text-[140px] font-bold text-[#F68A31] leading-none tracking-tighter">
          404
        </h1>
        
        <h2 className="text-3xl md:text-4xl font-semibold mt-4">
          {t.subtitle}
        </h2>
        
        <p className="mt-4 text-white/60 text-sm md:text-base">
          {t.description}
        </p>
        
        <Link 
          to="/" 
          className="btn-primary mt-10 inline-flex items-center justify-center px-8 py-3 font-medium text-black transition-transform hover:scale-105"
        >
          {t.button}
        </Link>
      </motion.div>
    </div>
  );
}